import {
  TableLayoutFilters,
  TableLayoutSearchInput,
} from 'common/components/Layouts/TableLayout/TableLayout.tsx';
import { TextField } from 'common/components/Inputs/TextField/TextField.tsx';
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
import { productsManagementFileNameFilterAtom } from 'atoms/filters/products-management-filters.ts';
import { ProductsManagementFiltersModal } from '@/activityLog/productsManagement/Filters/ProductsManagementFiltersModal.tsx';

export const ProductsManagementFilters = () => {
  const { t } = useTranslation();
  const [fileName, setFileName] = useAtom(productsManagementFileNameFilterAtom);

  return (
    <TableLayoutFilters>
      <TableLayoutSearchInput>
        <TextField
          data-testid={'products management file name input'}
          value={fileName}
          onChange={(event) => setFileName(event.target.value)}
          label={t('common.fileName')}
          showSearchIcon={true}
        />
      </TableLayoutSearchInput>
      <ProductsManagementFiltersModal />
    </TableLayoutFilters>
  );
};
